import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';
import type { ComicItem } from '@/mocks/comics';

function ComicCard({ comic, index }: { comic: ComicItem; index: number }) {
  const bgColors = [
    'bg-primary-100/40',
    'bg-accent-100/40',
    'bg-secondary-100/40',
    'bg-background-200/60',
    'bg-primary-100/30',
    'bg-accent-100/30',
    'bg-secondary-100/30',
    'bg-background-200/50',
  ];
  const bgColor = bgColors[index % bgColors.length];

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group rounded-2xl overflow-hidden cursor-pointer block transition-transform duration-300 hover:-translate-y-1"
    >
      <div className={`${bgColor} p-3 md:p-4`}>
        <div className="relative overflow-hidden rounded-xl aspect-[3/4]">
          <img
            src={comic.cover}
            alt={comic.title}
            loading="lazy"
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-primary-600">
            {comic.rating}
          </div>
        </div>
      </div>
      <div className="px-3 md:px-4 pb-3 md:pb-4 pt-2 bg-background-50">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-accent-600 font-medium">{comic.latestChapter}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-xs rounded-md bg-background-100 text-foreground-600"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs md:text-sm text-accent-600 font-medium tracking-wider uppercase">
              每日更新
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mt-1">
              最新<span className="text-primary-500 italic font-serif">上架</span>漫画
            </h2>
          </div>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 mt-3 md:mt-0 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic, index) => (
            <ComicCard key={comic.id} comic={comic} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}